import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpClient, HttpErrorResponse, } from '@angular/common/http';
import { CookieService } from "ngx-cookie-service";
import { User } from '../classes/user';
import { Router } from '@angular/router';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    isUserSigned = false;
    API_AUTH_URL = config.serverAddress + ':' + config.serverPort + '/auth/';
    @Output() userSignedIn = new EventEmitter<User>();
    @Output() userSignedOut = new EventEmitter();
    @Output() signInFailed = new EventEmitter();

    constructor(private http: HttpClient,
                private router: Router,
                private cookieService: CookieService) { }

    isUserSignedIn() {
        return this.http.get(this.API_AUTH_URL + 'check');
    }

    signIn(user: User) {
        return this.http.post(this.API_AUTH_URL + 'login', user)
            .subscribe({
                next: (response: any) => {
                    this.cookieService.set('token', response.token);

                    const userSignedIn = new User();
                    userSignedIn.IDUser = response.user.IDUser;
                    userSignedIn.Username = response.user.Username;
                    this.userSignedIn.emit(userSignedIn);
                    this.router.navigate(['/dashboard']);
                    return true;
                },
                error: (error: HttpErrorResponse) => {
                    console.log(error);
                    this.signInFailed.emit();
                }
            });
    }

    signOut() {
        this.cookieService.delete('token');
        this.userSignedOut.emit();
        this.isUserSigned = false;
    }

    getUser() {
        return this.http.get(this.API_AUTH_URL + 'user');
    }

    getToken(): string | null {
        return this.cookieService.get('token');
    }
}
